import React from 'react';
import styles from './GenericIcon.module.scss';
import profileGenericIconLight from './../../../assets/images/LightTheme/profile_generic_icon.svg';
import profileGenericIconDark from './../../../assets/images/DarkTheme/profile_generic_icon.svg';

type GenericIconProps = {
  className?: string;
  isLight?: boolean;
};

const GenericIcon: React.FC<GenericIconProps> = ({ className = '', isLight = false }) => {
  const profileIcon = isLight ? profileGenericIconLight : profileGenericIconDark;

  return (
    <div className={`${styles.genericIcon} ${className}`}>
      <img src={profileIcon} alt="" />
    </div>
  );
};

export default GenericIcon;
